<template>
  <div class="styles">
    <div
      v-for="style in styles"
      :key="style.value"
      :class="{
        styles__item: true,
        'styles__item--selected': style.value === letterNumberArtwork.style
      }"
      @click="handleSelect(style)"
    >
      <div
        :class="{
          'styles__text-preview': true,
          [`styles__text-preview--${style.value}`]: true
        }"
      >
        <img
          :src="`https://jiffy.imgix.net/gen/letters-pdp/${style.value}.png`"
          :alt="style.label"
          :class="`styles__image styles__image--${style.value}`"
        />
      </div>
      <div class="styles__label">{{ style.label }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useDtfStore } from "../store";

const styles = [
  { label: "Straight", value: "straight" },
  { label: "Vertical", value: "vertical" }
];

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);

const handleSelect = option => {
  const style = option.value;
  store.updateArtworkValues({ index: 0, style });
  store.updateAllLetterPreviews();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.styles {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;

  @include with-desktop {
    flex-wrap: wrap;
    overflow-x: unset;
  }

  &__item {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid $gray-label;
    padding: 16px;
    cursor: pointer;
    min-width: 140px;
    height: 150px;
    justify-content: space-between;
    align-items: center;

    &--selected {
      border-radius: 8px;
      border: 2px solid $primary-600;
      padding: 15px;
    }
  }

  &__image {
    width: 80px;

    &--arc {
      width: 90px;
    }

    &--vertical {
      width: 20px;
    }
  }

  &__label {
    color: $text-black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
  }

  &__text-preview {
    &--straight {
      padding-top: 32px;
    }

    &--arc {
      padding-top: 20px;
    }
  }
}
</style>
